import React, { useState } from 'react';
import 'yet-another-react-lightbox/styles.css'; // Import the lightbox styles
import Lightbox from 'yet-another-react-lightbox';

import pic1 from '../assets/img/gallery/2/DSC_1008.jpg';
import pic2 from '../assets/img/gallery/2/DSC_1012.jpg';
import pic3 from '../assets/img/gallery/2/DSC_1024.jpg';
import pic4 from '../assets/img/gallery/2/DSC_1039.jpg';
import pic5 from '../assets/img/gallery/2/DSC_1054.jpg';
import pic6 from '../assets/img/gallery/2/DSC_1059.jpg';
import pic7 from '../assets/img/gallery/2/DSC_1071.jpg';
import pic8 from '../assets/img/gallery/2/DSC_1074.jpg';
import pic9 from '../assets/img/gallery/2/DSC_1079.jpg';
import pic10 from '../assets/img/gallery/2/DSC_1086-Edit.jpg';
import pic11 from '../assets/img/gallery/2/DSC_1088.jpg';
import pic12 from '../assets/img/gallery/2/DSC_1091.jpg';
import pic13 from '../assets/img/gallery/2/DSC_1096.jpg';
import pic14 from '../assets/img/gallery/2/DSC_1104.jpg';
import pic15 from '../assets/img/gallery/2/DSC_1109.jpg';
import pic1_1 from '../assets/img/gallery/1/DSC_2883-HDR.jpg'
import pic1_2 from '../assets/img/gallery/1/DSC_2898-HDR.jpg'
import pic1_3 from '../assets/img/gallery/1/DSC_2916-HDR.jpg'
import pic1_4 from '../assets/img/gallery/1/DSC_2932-HDR.jpg'
import pic1_5 from '../assets/img/gallery/1/DSC_2955-HDR.jpg'
import pic1_6 from '../assets/img/gallery/1/DSC_2967-HDR.jpg'
import pic1_7 from '../assets/img/gallery/1/DSC_2973-HDR.jpg'
import pic1_8 from '../assets/img/gallery/1/DSC_3000-HDR.jpg'
import pic1_9 from '../assets/img/gallery/1/DSC_3018-HDR.jpg'
import pic1_10 from '../assets/img/gallery/1/DSC_3048-HDR.jpg'
import pic1_11 from '../assets/img/gallery/1/DSC_3051-HDR.jpg'
import pic1_12 from '../assets/img/gallery/1/DSC_3060-HDR.jpg'
import pic1_13 from '../assets/img/gallery/1/DSC_3069-HDR.jpg'
import pic1_14 from '../assets/img/gallery/1/DSC_3093-HDR.jpg'


import { useTranslation } from 'react-i18next';

const images = [
  pic1, pic2, pic3, pic4, pic5, pic6, pic7, pic8, pic9, pic10, pic11, pic12, pic13, pic14, pic15, pic1_1, pic1_2, pic1_3, pic1_4, pic1_5, pic1_6, pic1_7, pic1_8, pic1_9, pic1_10, pic1_11, pic1_12, pic1_13, pic1_14
];

const Gallery = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [photoIndex, setPhotoIndex] = useState(0);
  const { t } = useTranslation();


  return (
    <section className='py-24' id='galeria'>
      <div className="text-center">
        <div className="font-tertiary uppercase text-[15px] tracking-[6px] ">
          {t("galeriaText")}
        </div>
        <h2 className="font-primary text-[45px] mb-4">{t("galeria")}</h2>
      </div>
    <div className="container mx-auto px-4 py-8">
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4">
        {images.map((image, index) => (
          <div key={index} className="relative">
            <img
              src={image}
              alt={`Gallery Image ${index + 1}`}
              className="w-full h-auto  aspect-[2/1.5]  object-cover cursor-pointer rounded shadow-lg hover:opacity-75 transition-opacity"
              onClick={() => {
                setPhotoIndex(index);
                setIsOpen(true);
              }}
            />
          </div>
        ))}
      </div>

      {isOpen && (
        <Lightbox
          open={isOpen}
          close={() => setIsOpen(false)}
          slides={images.map(image => ({ src: image }))}
          index={photoIndex}
          onIndexChange={setPhotoIndex}
        />
      )}
    </div>
    </section>
  );
};

export default Gallery;
